import script from "./OrganisationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganisationModal.vue?vue&type=script&setup=true&lang=js"

import "./OrganisationModal.vue?vue&type=style&index=0&id=6d7af046&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7af046"]])

export default __exports__